<template>
  <h5
    class="
      text-left
      mx-6
      my-3
      sm:my-6
      text-white
      w-full
      sm:w-50
      flex flex-col
      justify-evenly
    "
  >
    <p class="my-2 ">
      Start a new APROE Waterjet order using our quick quote application:
    </p>
    <p class="my-2 ">
      &nbsp; &nbsp; &#10003; Enter your name and email address<br>
      &nbsp; &nbsp; &#10003; Select your job detail material and units<br>
      &nbsp; &nbsp; &#10003; Upload a valid DXF file (or STEP for 5-axis) below<br>
      &nbsp; &nbsp; &#10003; Add multiple jobs to your quote by clicking "Add Job to this Order"
    </p>
    <p class="my-2 ">
      We offer quick turnaround times for quotes, in as little as one or two
      minutes.<br>
      Please review our
      <a
        class="text-secondary underline hover:text-white"
        href="https://aproe.com/file-guidelines/"
        target="_blank"
        rel="noopener noreferrer"
      >file guidelines</a>
      as well as our
      <a
        class="text-secondary underline hover:text-white"
        href="https://aproe.com/waterjet-faq/"
        target="_blank"
        rel="noopener noreferrer"
      >Waterjet FAQ</a>. Including the advantages of nesting multiple parts.
    </p>
    <p class="my-2">We can coordinate shipping or local delivery with you separately if required.</p>
  </h5>
</template>
<script>
export default {
  name: 'InformationText',
}
</script>
